import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  TitleListRequest,
  TitleListResponse,
  Title,
  TitleShortListRequest,
  TitleShortListResponse,
  TitleCreateRequest,
  TitleUpdateRequest,
} from "./types";

/**
 * List
 */
export const titleListService = (params: TitleListRequest) =>
  RestAPIClient.call<TitleListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * List short
 */
export const titleListShortService = (params: TitleShortListRequest) =>
  RestAPIClient.call<TitleShortListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * Detail
 */
export const titleDetailService = (id: number) =>
  RestAPIClient.call<Title>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Create
 */
export const titleCreateService = (data: TitleCreateRequest) =>
  RestAPIClient.call<Title>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.Create}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update
 */
export const titleUpdateService = (data: TitleUpdateRequest) =>
  RestAPIClient.call<Title>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${data.id}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });
